import { render, staticRenderFns } from "./DetailsReturn.vue?vue&type=template&id=daae2e34&"
import script from "./DetailsReturn.vue?vue&type=script&lang=js&"
export * from "./DetailsReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports